/**
 * Main Book LP API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AssetBasedStrategyStatusDto {
  id?: number;
  internalPosition?: number;
  externalPosition?: number;
  deltaTotal?: number;
  lastTsoeUpdate?: string;
  hasActiveTask?: boolean;
  spotOpenPnl?: number;
  perpOpenPnl?: number;
}
